import { jsx as N, jsxs as H } from "react/jsx-runtime";
import * as C from "react";
import { createContext as K, useContext as Z, useRef as k, useId as ae, useCallback as M, useEffect as P, useMemo as Q, useState as S, forwardRef as F } from "react";
import { createPortal as fe } from "react-dom";
import { u as X } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { c as Y } from "./tw-cn-mXgPecoF.mjs";
let $;
process.env.NODE_ENV !== "production" && ($ = /* @__PURE__ */ new Set());
function W(...e) {
  if (process.env.NODE_ENV !== "production") {
    const t = e.join(" ");
    $.has(t) || ($.add(t), console.error(`Base UI: ${t}`));
  }
}
function de({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = C.useRef(e !== void 0), [i, s] = C.useState(t), u = r ? e : i;
  if (process.env.NODE_ENV !== "production") {
    C.useEffect(() => {
      r !== (e !== void 0) && W([`A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: c
    } = C.useRef(t);
    C.useEffect(() => {
      !r && q(c) !== q(t) && W([`A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [t]);
  }
  const f = C.useCallback((c) => {
    r || s(c);
  }, []);
  return [u, f];
}
function q(e) {
  let t = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(e, function(i, s) {
      if (!(i === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof s == "bigint")
          return `__bigint__:${s}`;
        if (s !== null && typeof s == "object") {
          const u = n.get(s);
          if (u !== void 0)
            return `__object__:${u}`;
          n.set(s, t), t += 1;
        }
        return s;
      }
    }) ?? `__top__:${typeof e}`;
  } catch {
    return "__unserializable__";
  }
}
const ee = K(null), me = ee.Provider;
function z() {
  const e = Z(ee);
  if (!e)
    throw new Error("[Menu] Menu.Trigger / Menu.Content / Menu.Item은 <Menu> 내부에서만 사용할 수 있습니다.");
  return e;
}
const te = ({
  children: e,
  open: t,
  defaultOpen: n = !1,
  onOpenChange: o,
  side: r = "bottom",
  align: i = "start",
  offset: s = 8,
  dismissOnOutsideClick: u = !0,
  dismissOnEscape: f = !0,
  returnFocusOnClose: c = !0
}) => {
  const [l, a] = de({
    controlled: t,
    default: n,
    name: "Menu",
    state: "open"
  }), m = k(null), h = k(null), d = ae(), w = k(l), E = k(null), b = M(
    (x) => {
      a(x), o == null || o(x);
    },
    [a, o]
  ), D = M(() => {
    b(!l);
  }, [b, l]), y = M(
    (x = "programmatic") => {
      b(!1);
    },
    [b]
  );
  P(() => {
    if (!l) return;
    const x = (_) => {
      _.key === "Escape" && f && y("escape");
    }, L = (_) => {
      var A, T;
      if (!u) return;
      const v = _.target;
      v && ((A = m.current) != null && A.contains(v) || (T = h.current) != null && T.contains(v) || y("outside-click"));
    };
    return document.addEventListener("keydown", x), document.addEventListener("pointerdown", L, !0), () => {
      document.removeEventListener("keydown", x), document.removeEventListener("pointerdown", L, !0);
    };
  }, [l, y, f, u]), P(() => {
    const x = w.current;
    if (w.current = l, !x || l || !c) return;
    const L = requestAnimationFrame(() => {
      var _;
      (_ = m.current) == null || _.focus({ preventScroll: !0 });
    });
    return () => {
      cancelAnimationFrame(L);
    };
  }, [l, c]);
  const p = Q(
    () => ({
      open: l,
      contentId: d,
      triggerRef: m,
      contentRef: h,
      initialItemFocusRef: E,
      side: r,
      align: i,
      offset: s,
      toggle: D,
      close: y
    }),
    [l, d, r, i, s, D, y]
  );
  return /* @__PURE__ */ N(me, { value: p, children: e });
};
te.displayName = "NDS.Menu";
const ne = K(null);
function pe() {
  const e = Z(ne);
  if (!e)
    throw new Error("[CompositeList] useCompositeListItem must be used inside <CompositeListProvider>.");
  return e;
}
function be(e) {
  return [...e].sort((t, n) => {
    if (t === n) return 0;
    const o = t.compareDocumentPosition(n);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function ge({ elementsRef: e, children: t }) {
  const n = k(/* @__PURE__ */ new Set()), o = M(() => {
    const u = Array.from(n.current);
    e.current = be(u);
  }, [e]), r = M(
    (u) => {
      n.current.has(u) || (n.current.add(u), o());
    },
    [o]
  ), i = M(
    (u) => {
      n.current.delete(u) && o();
    },
    [o]
  ), s = Q(() => ({ register: r, unregister: i }), [r, i]);
  return /* @__PURE__ */ N(ne.Provider, { value: s, children: t });
}
function he() {
  const { register: e, unregister: t } = pe(), n = k(null), o = M(
    (r) => {
      const i = n.current;
      i !== r && (i && t(i), n.current = r, r && e(r));
    },
    [e, t]
  );
  return P(() => () => {
    n.current && (t(n.current), n.current = null);
  }, [t]), { ref: o };
}
const we = "aria-disabled";
function V(e) {
  return e.getAttribute(we) === "true";
}
function j(e) {
  for (let t = 0; t < e.length; t += 1)
    if (!V(e[t])) return t;
  return -1;
}
function O(e) {
  for (let t = e.length - 1; t >= 0; t -= 1)
    if (!V(e[t])) return t;
  return -1;
}
function G(e, t, n) {
  const o = e.length;
  if (o === 0) return -1;
  for (let r = 1; r <= o; r += 1) {
    const i = ((t + r * n) % o + o) % o;
    if (!V(e[i])) return i;
  }
  return -1;
}
function ve({ elementsRef: e }) {
  return { onKeyDown: M(
    (n) => {
      const o = e.current;
      if (o.length === 0) return;
      const r = o.findIndex((u) => u === document.activeElement);
      let i;
      switch (n.key) {
        case "ArrowDown":
          i = r < 0 ? j(o) : G(o, r, 1);
          break;
        case "ArrowUp":
          i = r < 0 ? O(o) : G(o, r, -1);
          break;
        case "Home":
          i = j(o);
          break;
        case "End":
          i = O(o);
          break;
        default:
          return;
      }
      if (n.preventDefault(), i === -1) return;
      const s = o[i];
      s.focus({ preventScroll: !0 }), s.scrollIntoView({ block: "nearest" });
    },
    [e]
  ) };
}
function xe({
  open: e,
  anchorEl: t,
  contentEl: n,
  preferredSide: o,
  align: r,
  offset: i
}) {
  const [s, u] = S(null);
  return X(() => {
    if (!e || !t || !n) {
      u(null);
      return;
    }
    const f = () => {
      const m = t.getBoundingClientRect(), h = n.getBoundingClientRect();
      u(
        ye({
          anchorRect: m,
          contentWidth: h.width,
          contentHeight: h.height,
          viewportWidth: window.innerWidth,
          viewportHeight: window.innerHeight,
          preferredSide: o,
          align: r,
          offset: i
        })
      );
    };
    f();
    let c = null;
    const l = () => {
      c === null && (c = window.requestAnimationFrame(() => {
        c = null, f();
      }));
    };
    window.addEventListener("scroll", l, !0), window.addEventListener("resize", l);
    const a = new ResizeObserver(l);
    return a.observe(t), a.observe(n), () => {
      c !== null && window.cancelAnimationFrame(c), window.removeEventListener("scroll", l, !0), window.removeEventListener("resize", l), a.disconnect();
    };
  }, [e, t, n, o, r, i]), s;
}
function ye({
  anchorRect: e,
  contentWidth: t,
  contentHeight: n,
  viewportWidth: o,
  viewportHeight: r,
  preferredSide: i,
  align: s,
  offset: u
}) {
  const f = r - e.bottom, c = e.top, l = n + u;
  let a, m;
  const h = i === "bottom" ? f >= l : c >= l, d = i === "bottom" ? c >= l : f >= l;
  h ? a = i : d ? a = i === "bottom" ? "top" : "bottom" : a = "cover", a === "bottom" ? m = e.bottom + u : a === "top" ? m = e.top - n - u : m = Math.max(0, Math.min(e.top, r - n));
  let w;
  s === "start" ? w = e.left : s === "center" ? w = e.left + e.width / 2 - t / 2 : w = e.right - t;
  const E = Math.max(0, o - t);
  return w = Math.max(0, Math.min(w, E)), {
    top: m,
    left: w,
    resolvedSide: a,
    resolvedAlign: s
  };
}
const J = {};
function Ie(e, t) {
  const n = C.useRef(J);
  return n.current === J && (n.current = e(t)), n;
}
function U(e, t, n, o) {
  const r = Ie(Ne).current;
  return Me(r, e, t, n, o) && _e(r, [e, t, n, o]), r.callback;
}
function Ne() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function Me(e, t, n, o, r) {
  return e.refs[0] !== t || e.refs[1] !== n || e.refs[2] !== o || e.refs[3] !== r;
}
function _e(e, t) {
  if (e.refs = t, t.every((n) => n == null)) {
    e.callback = null;
    return;
  }
  e.callback = (n) => {
    if (e.cleanup && (e.cleanup(), e.cleanup = null), n != null) {
      const o = Array(t.length).fill(null);
      for (let r = 0; r < t.length; r += 1) {
        const i = t[r];
        if (i != null)
          switch (typeof i) {
            case "function": {
              const s = i(n);
              typeof s == "function" && (o[r] = s);
              break;
            }
            case "object": {
              i.current = n;
              break;
            }
          }
      }
      e.cleanup = () => {
        for (let r = 0; r < t.length; r += 1) {
          const i = t[r];
          if (i != null)
            switch (typeof i) {
              case "function": {
                const s = o[r];
                typeof s == "function" ? s() : i(null);
                break;
              }
              case "object": {
                i.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const Ee = ({
  itemTop: e,
  itemHeight: t,
  firstItemTop: n,
  viewportHeight: o
}) => e + t <= o ? 0 : Math.max(0, e - n), Ce = "flex max-h-[420px] flex-col overflow-y-auto rounded-16 border border-line-neutral-weak2 bg-static-white py-8 shadow-2 outline-none", re = F(function({ children: t, container: n, style: o, className: r, onKeyDown: i, ...s }, u) {
  const { open: f, contentId: c, contentRef: l, triggerRef: a, initialItemFocusRef: m, side: h, align: d, offset: w, close: E } = z(), [b, D] = S(null), [y, p] = S(!1), x = k([]);
  P(() => {
    p(!0);
  }, []);
  const L = M((g) => {
    D(g);
  }, []), _ = U(u, l, L), v = xe({
    open: f,
    anchorEl: a.current ?? null,
    contentEl: b,
    preferredSide: h,
    align: d,
    offset: w
  }), { onKeyDown: A } = ve({ elementsRef: x });
  X(() => {
    if (!f || !b) return;
    const g = x.current, R = m.current;
    m.current = null;
    const B = g.findIndex(
      (I) => I.getAttribute("data-selected") === "true" && I.getAttribute("aria-disabled") !== "true"
    );
    if (B !== -1) {
      const I = g[B];
      I.focus({ preventScroll: !0 }), b.scrollTop = Ee({
        itemTop: I.offsetTop,
        itemHeight: I.offsetHeight,
        firstItemTop: g[0].offsetTop,
        viewportHeight: b.clientHeight
      });
      return;
    }
    if (R === "first" || R === "last") {
      const I = R === "first" ? j(g) : O(g);
      if (I !== -1) {
        g[I].focus();
        return;
      }
    }
    b.focus();
  }, [f, b, m]);
  const T = (g) => {
    if (i == null || i(g), !g.defaultPrevented) {
      if (g.key === "Tab") {
        g.preventDefault(), E("tab");
        return;
      }
      A(g);
    }
  };
  if (!f || !y) return null;
  const se = n ?? document.body, ue = v ? { position: "fixed", top: v.top, left: v.left, visibility: "visible" } : (
    // 첫 measurement 이전: (0,0)에 렌더하되 보이지 않지만 **focus는 여전히 가능**한 상태.
    // `visibility: hidden`을 쓰면 안 되는 이유: CSS 스펙상 hidden 요소의 자손은
    // 프로그래매틱 `.focus()`를 받지 못한다.
    // opacity: 0은 focusable, pointer-events: none은 클릭 가로채기 방지.
    { position: "fixed", top: 0, left: 0, opacity: 0, pointerEvents: "none" }
  ), le = (v == null ? void 0 : v.resolvedSide) ?? h, ce = (v == null ? void 0 : v.resolvedAlign) ?? d;
  return fe(
    /* @__PURE__ */ N(ge, { elementsRef: x, children: /* @__PURE__ */ N(
      "div",
      {
        className: Y(Ce, r),
        "data-align": ce,
        "data-side": le,
        "data-state": "open",
        id: c,
        onKeyDown: T,
        ref: _,
        role: "menu",
        style: { ...ue, ...o },
        tabIndex: -1,
        ...s,
        children: t
      }
    ) }),
    se
  );
});
re.displayName = "NDS.Menu.Content";
const ke = "mx-8 my-2 flex h-44 min-h-44 cursor-pointer items-center gap-8 rounded-12 px-16 py-4 outline-none typography-subtitle-16-regular text-text-neutral-main hover:bg-interaction-neutral-presshover-weak1 focus-visible:bg-interaction-neutral-presshover-weak1 data-[selected=true]:typography-subtitle-16-bold data-[selected=true]:bg-fill-neutral-weak data-[selected=true]:hover:bg-interaction-neutral-presshover-weak1 data-[selected=true]:focus-visible:bg-interaction-neutral-presshover-weak1 aria-disabled:cursor-not-allowed aria-disabled:hover:bg-transparent aria-disabled:focus-visible:bg-transparent [&[aria-disabled=true]_[data-menu-item-slot=leading]]:opacity-20 [&[aria-disabled=true]_[data-menu-item-slot=trailing]]:opacity-20 [&[aria-disabled=true]_[data-menu-item-slot=label]]:text-interaction-neutral-disable-main [&[aria-disabled=true]_[data-menu-item-slot=info-icon]]:text-interaction-neutral-disable-main", oe = F(function({
  value: t,
  disabled: n = !1,
  selected: o = !1,
  leadingElement: r,
  trailingElement: i,
  infoIcon: s,
  onSelect: u,
  children: f,
  className: c,
  onClick: l,
  onKeyDown: a,
  ...m
}, h) {
  const { close: d } = z(), { ref: w } = he(), E = U(h, w), b = (p) => {
    u == null || u(p), p.defaultPrevented || d("select");
  }, D = (p) => {
    n || (l == null || l(p), !p.defaultPrevented && b(p));
  }, y = (p) => {
    n || (a == null || a(p), !p.defaultPrevented && (p.key === "Enter" || p.key === " ") && (b(p), p.preventDefault()));
  };
  return /* @__PURE__ */ H(
    "div",
    {
      "aria-current": o || void 0,
      "aria-disabled": n || void 0,
      className: Y(ke, c),
      "data-selected": o || void 0,
      "data-value": t,
      onClick: D,
      onKeyDown: y,
      ref: E,
      role: "menuitem",
      tabIndex: -1,
      ...m,
      children: [
        r != null && // Figma: 24×24. `[&>*]:size-24`로 자식(아이콘)에 강제.
        // nol-icons가 기본 24이므로 실질 no-op이지만, 다른 노드(img 등)에도 사이즈 보장.
        /* @__PURE__ */ N("span", { className: "flex shrink-0 items-center [&>*]:size-24", "data-menu-item-slot": "leading", children: r }),
        /* @__PURE__ */ H("span", { className: "flex min-w-0 flex-1 items-center", children: [
          /* @__PURE__ */ N("span", { className: "min-w-0 truncate", "data-menu-item-slot": "label", children: f }),
          s != null && // Figma: 32×32 touch area 안에 16×16 아이콘. hit target 확보 목적.
          // `[&>*]:size-16`로 자식 아이콘 사이즈 강제 (nol-icons 기본 24 → 16으로 축소).
          /* @__PURE__ */ N(
            "span",
            {
              className: "flex h-full w-32 shrink-0 items-center justify-center text-fill-neutral-strong1 [&>*]:size-16",
              "data-menu-item-slot": "info-icon",
              children: s
            }
          )
        ] }),
        i != null && // ml-auto: leadingElement/label/infoIcon 이후 남는 공간을 모두 소비해 우측 끝 고정.
        // (부모 Menu.Content 폭이 어떻든 trailingElement는 항상 우측 정렬)
        // Figma: 24×24. `[&>*]:size-24`로 자식 사이즈 강제.
        /* @__PURE__ */ N("span", { className: "ml-auto flex shrink-0 items-center [&>*]:size-24", "data-menu-item-slot": "trailing", children: i })
      ]
    }
  );
});
oe.displayName = "NDS.Menu.Item";
const ie = F(function({ onClick: t, onKeyDown: n, children: o, ...r }, i) {
  const { open: s, contentId: u, triggerRef: f, toggle: c, initialItemFocusRef: l } = z(), a = U(i, f);
  return /* @__PURE__ */ N(
    "button",
    {
      "aria-controls": s ? u : void 0,
      "aria-expanded": s,
      "aria-haspopup": "menu",
      onClick: (d) => {
        t == null || t(d), !d.defaultPrevented && c();
      },
      onKeyDown: (d) => {
        n == null || n(d), !d.defaultPrevented && (s || (d.key === "ArrowDown" ? (d.preventDefault(), l.current = "first", c()) : d.key === "ArrowUp" && (d.preventDefault(), l.current = "last", c())));
      },
      ref: a,
      type: "button",
      ...r,
      children: o
    }
  );
});
ie.displayName = "NDS.Menu.Trigger";
const Re = Object.assign(te, {
  Trigger: ie,
  Content: re,
  Item: oe
});
export {
  Re as Menu,
  z as useMenuContext
};
